import React from 'react';
import useUserContext from 'Context/UserContext';
import OutOfOfficeModalUpdate from 'Components/Modals/OutOfOffice';

const OutOfOfficeComponentPicker = ({ isMobile, ...rest }) => {
  const { agentResource } = useUserContext();

  if (!agentResource) {
    return null;
  }

  return <OutOfOfficeModalUpdate {...rest} />;
};

export default OutOfOfficeComponentPicker;
